// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bulk-actions{margin-right:16px}.bulk-actions .title{width:100%;text-align:center}.bulk-actions .action-card{left:0}", ""]);
// Exports
module.exports = exports;
